module.exports = __webpack_public_path__ + "static/media/img_13.78037a5a.png";